<template>
  <div
    class="app-search"
    :class="{'app-search--expanded': isExpanded}"
  >
    <div
      class="app-search__wrapper"
      :class="appSearchWrapperStyles"
    >
      <button
        v-if="showBackButton"
        class="app-search__close-icon mr-25"
        @click="handleClose"
      >
        <font-awesome-icon icon="chevron-left" />
      </button>
      <input
        v-if="isExpanded"
        :value="searchText"
        type="text"
        :name="name"
        :placeholder="placeholder"
        class="app-search__input"
        @keydown.enter="handleSearch"
        @input="handleInput"
        @keydown.escape="handleClose"
        @focus="handleFocus"
        @blur="focused = false"
      >
      <button
        v-if="searchText"
        class="app-search__close-icon"
        @click="handleClose"
      >
        <font-awesome-icon icon="xmark" />
      </button>
      <button
        v-else
        class="app-search__search-icon"
        :class="{
          'app-search__search-icon--active': isExpanded && searchText !== '' && searchText.length >= 3,
        }"
        @click="isExpanded ? handleSearch() : handleExpandInput()"
      >
        <font-awesome-icon icon="magnifying-glass" />
      </button>
    </div>
    <button
      v-if="full"
      class="app-search__button"
      @click="handleSearch"
    >
      Search
    </button>
  </div>
</template>

<script>
export default {
  name: 'AppSearch',

  props: {
    name: {
      type: String,
      default: 'hello'

    },

    value: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: ''
    },

    expandable: {
      type: Boolean,
      default: false
    },

    full: {
      type: Boolean,
      default: false
    },

    searchText: {
      type: String,
      default: ''
    },

    showBackButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      toggle: false,
      focused: false
    }
  },

  computed: {
    isExpanded () {
      return this.expandable ? this.toggle : true
    },

    closeIconVisible () {
      if (this.expandable) return this.toggle
      return this.searchText && this.isExpanded !== ''
    },

    appSearchWrapperStyles () {
      return {
        'app-search__wrapper--transparent': this.expandable,
        'app-search__wrapper--full': this.full,
        'app-search__wrapper--focused': this.focused
      }
    }
  },

  methods: {
    handleInput (event) {
      this.$emit('input', event.target.value)
    },

    handleExpandInput () {
      if (!this.expandable) return
      this.toggle = !this.toggle
      this.$emit('expand', this.toggle)
    },

    handleSearch (event) {
      if (this.searchText !== '' && this.searchText.length >= 3) {
        this.$emit('search', this.searchText)
        this.handleClose()
      }
    },

    handleClose () {
      this.$emit('close')
      this.handleExpandInput()
    },

    handleFocus () {
      this.focused = true
      this.$emit('focus')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-search {
  @apply font-heading max-w-800 flex h-50 duration-300;

  &--expanded {
    @apply w-full;
  }

  &__wrapper {
    @apply bg-white border border-gray-300 text-gray-350 rounded-full;
    @apply relative flex justify-end items-center w-full p-15;

    &--focused {
      @apply border border-purple-500;
    }

    &--full {
      @apply rounded-l-5 rounded-r-0;

      .app-search {
        &__input {
          @apply ml-50;
        }

        &__search-icon {
          @apply absolute left-[25px] cursor-auto;
        }

        &__close-icon {
          @apply mr-0;
        }
      }
    }
  }

  &__input {
    @apply w-full bg-transparent font-medium outline-none font-body;

    &::placeholder {
      @apply text-[#818181];
    }
  }

  &__search-icon {
    @apply text-lg hover:text-purple-400 duration-300 cursor-pointer;

    &--active {
      @apply text-purple-400;
    }
  }

  &__close-icon {
    @apply cursor-pointer text-lg h-30 text-purple-400;
  }

  &__button {
    @apply bg-purple-400 py-15 px-35 text-white font-bold text-lg rounded-r-5 flex items-center;
    @apply hover:bg-purple-500 duration-300;
  }
}
</style>
